import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowDown({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="attributeArrow"
    >
      <path
        d="M7.00125 6.1092C6.7676 6.1096 6.54116 6.03859 6.36125 5.90851L0.361252 1.54557C0.157036 1.39746 0.0286112 1.18463 0.0042315 0.953891C-0.0201482 0.723156 0.0615137 0.49342 0.231252 0.315224C0.400991 0.137027 0.644902 0.0249658 0.909329 0.00369237C1.17375 -0.0175811 1.43704 0.0536756 1.64125 0.201787L7.00125 4.11098L12.3613 0.341402C12.4635 0.26892 12.5812 0.214791 12.7076 0.182129C12.8339 0.149467 12.9664 0.138914 13.0974 0.151077C13.2285 0.16324 13.3554 0.197879 13.4711 0.253004C13.5867 0.308128 13.6887 0.382652 13.7713 0.47229C13.8628 0.56201 13.9322 0.667267 13.975 0.781466C14.0178 0.895664 14.0331 1.01634 14.0199 1.13594C14.0068 1.25554 13.9655 1.37149 13.8986 1.47651C13.8317 1.58153 13.7407 1.67337 13.6313 1.74627L7.63125 5.96086C7.44617 6.07038 7.22435 6.12261 7.00125 6.1092Z"
        fill={color}
      />
    </svg>
  );
}

ArrowDown.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

ArrowDown.defaultProps = {
  color: '#000',
  width: 15,
  height: 7,
};
